/* ═══════════════════════════════════════════════════
   DWL — "Full set" voegt hét set-product toe

   HET PROBLEEM
   De bundelkaart bouwde de volledige set op uit de losse producten: de
   knop had data-set-variants met zeven variant-id's, die één voor één in
   de wagen belandden en daarna tot een bundel werden gesmeed. Dat geeft
   zeven regels in de winkelwagen, zeven kansen dat er iets misgaat, en
   een bestelling die er anders uitziet dan wat de klant koos.

   Inmiddels bestaan de sets als één echt product:
     Jurassic Ducks — Complete Set   handle jurassic-ducks-complete-set
     Crypto Ducks — Complete Set     handle crypto-ducks-complete-set

   Dit script vangt de klik op zo'n set-knop af vóór de bundel-JS (capture
   + stopImmediatePropagation) en legt dat ene product in de wagen.

   ⚠ Werkt op de collectiepagina's én op elke losse productpagina van
   die twee collecties, want de kaart wordt daar met dezelfde snippet
   gerenderd.

   ⚠ Komt er een derde set bij, zet 'm dan in SETS hieronder. De
   koppeling is niet automatisch af te leiden: de bundelkaart kent alleen
   de collectie, en de naam van het set-product volgt daar niet
   dwingend uit.
   ════════════════════════════════════════════════════ */
(function () {

  /* Zoekwoord in de bundel-handle of collectie → handle van het
     set-product. Kleine letters. */
  var SETS = [
    { match: 'jurassic', handle: 'jurassic-ducks-complete-set' },
    { match: 'crypto',   handle: 'crypto-ducks-complete-set' }
  ];

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/').replace(/\/$/, '');
  }

  /* Welke set hoort bij deze kaart? Kijk naar de bundel-handle, de
     categorie van de picker en anders naar de URL van de pagina. */
  function setFor(card) {
    var hay = '';
    if (card) {
      hay += (card.getAttribute('data-bundle-handle') || '') + ' ';
      var modal = card.querySelector('[data-modal]');
      if (modal) hay += (modal.getAttribute('data-current-cat') || '') + ' ';
      hay += (card.getAttribute('data-current-title') || '') + ' ';
    }
    hay += ' ' + window.location.pathname;
    hay = hay.toLowerCase();

    for (var i = 0; i < SETS.length; i++) {
      if (hay.indexOf(SETS[i].match) !== -1) return SETS[i];
    }
    return null;
  }

  function refreshCart() {
    try {
      if (window.DWLCart && typeof window.DWLCart.refreshCartUI === 'function') {
        window.DWLCart.refreshCartUI();
      }
      if (window.DWLCart && typeof window.DWLCart.openDrawer === 'function') {
        window.DWLCart.openDrawer();
      }
    } catch (e) {}

    fetch(root() + '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var els = document.querySelectorAll('.cart-count');
        for (var i = 0; i < els.length; i++) els[i].textContent = cart.item_count;
      })
      .catch(function () {});
  }

  function addSet(btn, set) {
    var original = btn.getAttribute('data-dwl-label') || btn.innerHTML;
    btn.setAttribute('data-dwl-label', original);
    btn.classList.add('is-loading');

    fetch(root() + '/products/' + set.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) throw new Error('sold out');
        return fetch(root() + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
      })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) throw new Error('failed');
        refreshCart();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        /* Lukt het niet, stuur dan naar de productpagina in plaats van
           stilletjes niets te doen. */
        window.location.href = root() + '/products/' + set.handle;
      });
  }

  /* Capture-fase: vóór de listener van bundle-deal-card.js, zodat die de
     losse producten niet alsnog toevoegt. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bundle-deal-tier--set, [data-tier-set="1"]');
    if (!btn) return;

    var card = btn.closest('.bundle-deal-card');
    var set = setFor(card);
    if (!set) return;   /* geen bekende set: laat het oude gedrag staan */

    e.preventDefault();
    e.stopImmediatePropagation();
    addSet(btn, set);
  }, true);

})();
